import React from 'react';

function menuToggler(WrappedComponent) {
  return class MenuToggleComponent extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        activeMenu: null,
      };
    }

    activateMenu = menu => {
      let activeMenu = null;
      if (this.state.activeMenu !== menu) {
        activeMenu = menu;
      }
      this.setState({
        activeMenu,
      });
    }

    isActiveMenu = menu => {
      return this.state.activeMenu === menu;
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          activateMenu={this.activateMenu}
          isActiveMenu={this.isActiveMenu}
        />
      );
    }
  };
}

export default menuToggler;



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/menuToggler.js